import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export interface VisitRequest {
  id: number;
  name: string;
  phone: string;
  team_size: number;
  preferred_visit_date: string;
  office_id: number;
  created_at: string;
  status: "new" | "progress" | "done" | "close";
}

export function VisitRequestsAPI(baseUrl: string) {
  return {
    get: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/visit-requests/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<VisitRequest[]>;
    },
    updateStatus: async (
      id: number,
      status: "new" | "progress" | "done" | "close",
    ) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.post(
        `${baseUrl}/visit-requests/${id}/?business_profile_id=${businessProfileId}`,
        { status },
        true,
      )) as ApiResponse<VisitRequest>;
    },
  };
}
